module.exports = __webpack_public_path__ + "img/intro.1237cac8.jpg";